module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "md",
      "fixed": "top",
      "type": "light",
      "variant": "light"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'Hello'
      }
    }
  }, [_c('span', [_vm._v("Le11e.me")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [(_vm.$store.getters.user === null) ? _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Sign in")])], 1) : _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Logout'
      }
    }
  }, [_vm._v("Logout")])], 1), _vm._v(" "), (_vm.$store.getters.user !== null) ? _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_vm._v("Profile")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.user !== null) ? _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'VenueAdd'
      }
    }
  }, [_vm._v("Add Venue")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bfca91c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = 664
// module chunks = 1